// extracted by mini-css-extract-plugin
export default {"tooltipMsg":"EFQ3c_NsV7ukBasZM1v8-","lockIcon":"_2emrCuoKHYOskzIfLrY9kI","disabledRow":"PvOTfOD9G0jIQeo2cpu7"};